import get from 'lodash/get'
import { computed, ref } from 'vue'

// Config is a global state for now
const configRef = ref<Config | null>(null)

export default function useConfig(config: Config | null = null) {
  if (config !== null) {
    configRef.value = config
  }

  const internalName = computed<string>(() => configRef.value?.theme_dir ?? '')
  const messages = computed<boolean>(() => configRef.value?.messages === true)

  function hasFeature(featureName: string): boolean {
    return true === get(configRef.value, featureName)
  }

  function isAdmin(): boolean {
    return true === configRef.value?.isAdmin
  }

  function isTheme(...themes: string[]) {
    if (themes.length === 0) {
      return false
    }

    return themes.includes(internalName.value)
  }

  return {
    // Ref
    conf: configRef,
    // Computed
    messages,
    internalName,
    // Methods
    isTheme,
    hasFeature,
    isAdmin,
  }
}
